import { render, staticRenderFns } from "./ProjectInitiationModal.vue?vue&type=template&id=ca666bd6&"
import script from "./ProjectInitiationModal.vue?vue&type=script&lang=js&"
export * from "./ProjectInitiationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports